module.exports = __webpack_public_path__ + "img/subs_down.bb69ce7d.svg";